import React, { Component } from "react"
import * as SelectionFactoryHelper from "../../../helpers/SelectionFactoryHelper"

export default class MerchantPageProductBanner extends Component {
  render() {
    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.buttonColor)
    const buttonStyle = this.props.buttonTextColor ? { color: this.props.buttonTextColor } : undefined
    const backgroundColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.backgroundColor)
    return (
      <div className={`shoppage__infobox ${backgroundColor && backgroundColor}`}>
        <div className="right-side">
          <div className="store-image">
            <img src={this.props.image} data-epi-edit="Image" />
          </div>
        </div>
        <div className="left-side">
          <div className="description">
            <h2 data-epi-edit="Headline">{this.props.headline}</h2>
            <div className="maintext" data-epi-edit="Text">
              {this.props.text}
            </div>
            <a href={this.props.buttonLink}>
              <div style={buttonStyle} className={`button button--small no-shadow ${buttonColor && buttonColor}`}>
                <span className="text" data-epi-edit="ButtonText">
                  {this.props.buttonText}
                </span>
              </div>
            </a>
          </div>
        </div>
        <div className="clear"></div>
      </div>
    )
  }
}
